import React from 'react';

export default function WaLogThread({ messages, expandedId, onToggle }) {
  if (!messages?.length) {
    return <p className="text-sm text-gray-500 text-center py-8">No messages</p>;
  }
  const sorted = [...messages].sort((a, b) => (a.created_at || '').localeCompare(b.created_at || ''));
  return (
    <div className="space-y-3 max-h-[70vh] overflow-y-auto p-2">
      {sorted.map((row) => {
        const inbound = row.direction === 'inbound';
        return (
          <div key={row.id} className={`flex ${inbound ? 'justify-start' : 'justify-end'}`}>
            <div
              className={`max-w-[85%] rounded-2xl px-3 py-2 text-sm ${
                inbound ? 'bg-gray-100 text-gray-900 rounded-tl-sm' : 'bg-[#659A9B] text-white rounded-tr-sm'
              }`}
            >
              <p className="text-[10px] opacity-70 mb-1">
                {inbound ? 'In' : 'Out'} · {row.message_type || 'text'} · {(row.created_at || '').slice(0, 19)}
              </p>
              <p className="whitespace-pre-wrap break-words">{row.content}</p>
              {row.raw_payload && (
                <button
                  type="button"
                  className="text-[10px] underline mt-1 opacity-80"
                  onClick={() => onToggle?.(expandedId === row.id ? null : row.id)}
                >
                  {expandedId === row.id ? 'Hide payload' : 'Payload'}
                </button>
              )}
              {expandedId === row.id && row.raw_payload && (
                <pre className="mt-2 text-[10px] bg-black/10 p-2 rounded overflow-auto max-h-40">
                  {JSON.stringify(row.raw_payload, null, 2)}
                </pre>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
